const pricing = [
    "0% p.a. for 6 months with 2.28% processing fee (EIR at 4.87% p.a.) and prevailing interest rate applies thereafter (min $1,000)",
    "0% p.a. for for 12 months 4.38% processing fee (EIR at 5.06% p.a.), and prevailing interest rate applies thereafter (min S$1,000)"
];

export const PRICE_KEYS = {
    rates810204: "0% p.a. for 6 months with 0.99% processing fee (EIR at 2.13% p.a.), prevailing interest rate applies thereafter (min S$2,000)",
    rates810203: "1.88% p.a. for 6 months with 0% processing fee, and prevailing interest rate applies thereafter (min $2,000)",
    ratesHNW:  "0% p.a. for 6 months with 1.68% processing fee (EIR at 3.60% p.a.), prevailing interest rate applies thereafter (min S$2,000) *Be awarded with an automatic Ingersoll timepiece worth $358 with minimum approved Funds Transfer amount of S$10,000",
    ratesMbnkOuters: "2.38% p.a. for 6 months with 0% processing fee, prevailing interest rate applies thereafter (min S$2,000)",
    ratesDefault: Array.isArray(pricing) ? pricing : []
};

const getBasePricingKey = (index) => {
  if (Array.isArray(PRICE_KEYS.ratesDefault) && PRICE_KEYS.ratesDefault[index]) {
    return PRICE_KEYS.ratesDefault[index];
  }
  return "";
};
// const makePricingNode = (label, promo, schme) =>
//   label ? { [label]: { PROMO: promo, SCHME: schme } } : {};

export const PRICING_GROUPS = {
  BASE: {
    ...(getBasePricingKey(0) ? { [getBasePricingKey(0)]: { PROMO: "U", SCHME: "FT2086" } } : {}),
    ...(getBasePricingKey(1) ? { [getBasePricingKey(1)]: { PROMO: "Y", SCHME: "FT2082" } } : {})
  
  },
  HNW: {
    [PRICE_KEYS.ratesHNW]: { PROMO: "W", SCHME: "FT168F" },
  },
  MBANKOUTSIDERS: {
    [PRICE_KEYS.ratesMbnkOuters]: { PROMO: "M", SCHME: "FT238R" },
  },
  "810203": {
    [PRICE_KEYS.rates810203]: { PROMO: "T", SCHME: "FT188R" },
  },
  "810204": {
    [PRICE_KEYS.rates810204]: { PROMO: "X", SCHME: "FT099F" },
  },
};

const resolvePricingRequest = (group, type) => { 
  const g = String(group || "BASE").toUpperCase();
  const t = String(type || "PROMO").toUpperCase();

  const resolvedGroup = Object.prototype.hasOwnProperty.call(PRICING_GROUPS, g)
    ? g
    : "BASE";

  const resolvedType = t === "SCHME" ? "SCHME" : "PROMO";

  return { group: resolvedGroup, type: resolvedType };
};

export const toFetchPricingValue = (item, dataValue, type) => {
  const { group, type: resolvedType } = resolvePricingRequest(item, type);
  const mapping = PRICING_GROUPS[group];
  if (!mapping || dataValue == null) return "";

  const record = mapping[String(dataValue).trim()];
  if (!record) return "";

  if (typeof record === "object") {
    return record[resolvedType] || "";
  }

  return "";
};